var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',[_c('Content',{attrs:{"getCartProducts":_vm.getCartProducts}}),_vm._v(" "),_c('Footer',{attrs:{"cartProducts":_vm.cartProducts,"getCartProducts":_vm.getCartProducts}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-efeca338","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/router/AddProduct.vue
// module id = null
// module chunks = 